/**
 * Per-drop title row + sender chips (flat chrome, no nested card frames).
 */

import type { ReactNode } from 'react';

import { Layers } from 'lucide-react';

import { cn } from '@/lib/utils';

export function SenderChips({ senders }: { senders: string[] }) {
  return (
    <div className="flex flex-wrap gap-1">
      {senders.map((s, i) => (
        <span key={i} className="rounded-md bg-muted/80 px-1.5 py-0.5 text-[10px] text-muted-foreground">
          {s}
        </span>
      ))}
    </div>
  );
}

export function DropSection({
  title,
  senders,
  isFirst,
  children,
}: {
  title: string;
  senders: string[];
  isFirst: boolean;
  children: ReactNode;
}) {
  return (
    <div className={cn('space-y-2', !isFirst && 'mt-4 border-t border-border/35 pt-4')}>
      <div className="flex flex-wrap items-end gap-x-2 gap-y-1">
        <div className="flex min-w-0 items-center gap-1.5">
          <Layers className="h-3 w-3 shrink-0 text-muted-foreground/70" />
          <span className="min-w-0 break-words text-[11px] font-medium leading-snug text-foreground">{title}</span>
        </div>
        {senders.length > 0 ? <SenderChips senders={senders} /> : null}
      </div>
      {children}
    </div>
  );
}
